"use client";

import Link from "next/link";
import { useEffect } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

export default function AppErrorPage({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 text-foreground">
      <section className="w-full max-w-xl rounded-lg border border-border bg-card p-8 shadow-soft">
        <p className="text-[11px] font-black uppercase tracking-[0.22em] text-nv-red">Something went wrong</p>
        <h1 className="mt-3 font-display text-4xl leading-none">This page could not load.</h1>
        <Alert variant="destructive" className="mt-5" role="alert">
          <AlertCircle />
          <AlertTitle>Page loading failed</AlertTitle>
          <AlertDescription>
            The issue has been logged. You can retry the route or return home.
            {error.digest ? <p className="mt-2 text-xs">Reference: {error.digest}</p> : null}
          </AlertDescription>
        </Alert>
        <div className="mt-6 flex flex-wrap gap-3">
          <button type="button" onClick={reset} className="nv-button">Try again</button>
          <Link href="/" className="nv-button-secondary">Home</Link>
        </div>
      </section>
    </main>
  );
}
